import { Trans, useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import STRING_KEYS from '../../../language/keys';
import { formatLocations } from '../../../utils';
import { CustomTooltip } from '../../CustomTooltip';
import { PositionLocationProps } from './position-location';
import { UnderlineText } from './position-location.styled';

const PositionLocation = ({ position }: PositionLocationProps): JSX.Element => {
  const { t: translate } = useTranslation();

  return useMemo(() => {
    if (position.remotePosition) {
      return <>{translate(STRING_KEYS.REMOTE)}</>;
    }

    const locationStrings = formatLocations(position.locations);
    const primaryLocation = locationStrings[0];
    const otherLocations = locationStrings.slice(1);

    let moreLocationsLabel;
    if (otherLocations.length) {
      moreLocationsLabel = (
        <CustomTooltip
          title={ (
            <div>
              {otherLocations.map((location) => (
                <div key={ location }>{location}</div>
              ))}
            </div>
          ) }
        >
          <span>
            <Trans
              i18nKey={ STRING_KEYS.POSITION_LOCATION.X_MORE_LOCATIONS }
              values={ { locationsAmount: otherLocations.length } }
            >
              <UnderlineText />
            </Trans>
          </span>
        </CustomTooltip>
      );
    }

    return (
      <span>{primaryLocation} {moreLocationsLabel}</span>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [position.locations, position.remotePosition]);
};

export default PositionLocation;
